
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wolf/privacy-policy",
      function () {
        return require("private-next-pages/wolf/privacy-policy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wolf/privacy-policy"])
      });
    }
  